// @ts-check

/**
 * Transform eventTypeList to hierarchy node
 * @param _data {import("../../SnaPage").ApiEventTypeList}
 * [
 *      { id: "EVT0", pid: "EVT0", name: "root" },
 *      { id: "EVT1", pid: "EVT0", name: "政治事件" },
 *      { id: "EVT2", pid: "EVT0", name: "商業事件" },
 *      { id: "EVT3", pid: "EVT0", name: "家族事件" },
 *      { id: "EVT4", pid: "EVT0", name: "教育事件" },
 *      { id: "EVT5", pid: "EVT0", name: "工作事件" },
 *      { id: "EVT6", pid: "EVT0", name: "得獎事件" },
 * ]
 * @returns {import("../../SnaPage").EventListItemNode}
 */
const cvtToHierarchy = (_data) => {
  const data = JSON.parse(JSON.stringify(_data));
  let root = {};
  const o = Object.create(null); // store children
  // @ts-ignore
  data.forEach((a) => {
    if (!a.id || !a.pid) return;
    // eslint-disable-next-line no-param-reassign
    a.children = o[a.id] && o[a.id].children;
    o[a.id] = a;
    if (a.id === a.pid) {
      root = a;
    } else {
      o[a.pid] = o[a.pid] || {};
      o[a.pid].children = o[a.pid].children || [];
      o[a.pid].children.push(a);
    }
  });
  // @ts-ignore
  return root;
};

// 將階層式 data 轉成 list (多帶一個key => step:0,1,2...)

/**
 *
 * @param hierarchyDataRoot {import("../../SnaPage").EventListItemNode}
 * @param list {import("../../SnaPage").EventTypeList | []}
 * @param step {number}
 * @returns {import("../../SnaPage").EventTypeList}
 */
const cvt2DataStep = (hierarchyDataRoot, list = [], step = 0) => {
  /**
   *
   * @type {import("../../SnaPage").EventType}
   */
  // @ts-ignore
  const cur = {
    ...hierarchyDataRoot,
    checked: false,
    step,
  };
  // @ts-ignore
  list.push(cur);
  if (
    hierarchyDataRoot?.children &&
    Array.isArray(hierarchyDataRoot.children) &&
    hierarchyDataRoot.children.length > 0
  ) {
    hierarchyDataRoot.children.forEach((child) => {
      cvt2DataStep(child, list, step + 1);
    });
  }
  delete cur.children;
  return list;
};

const eventTypeHelper = { cvtToHierarchy, cvt2DataStep };
export default eventTypeHelper;
